// extracted by mini-css-extract-plugin
export default {"root":"ycrFRFyElTP7yug2N1RD","placeholder":"NOwd4jVIt81mnYQ80dKW"};